import { create } from "zustand";

export const useRebarProjectInfoStore = create((set) => ({

    projectName : "",
    setProjectName: (projectName) => set({ projectName }),

    projectId: -1,
    setProjectId: (projectId) => set({ projectId }),

    activated: false,
    setActivated: (activated) => set({ activated: activated }),

    projectCuttingPlanPermission: false,
    setProjectCuttingPlanPermission: (projectCuttingPlanPermission) => set({ projectCuttingPlanPermission }),

    purchasable: false,
    setPurchasable: (purchasable) => set({ purchasable }),

    ownProject: false,
    setOwnProject: (ownProject) => set({ ownProject }),

    userType: 0,
    setUserType: (userType) => set({ userType }),

    unitPrice: 0,
    setUnitPrice: (unitPrice) => set({ unitPrice }),

    unitDiscount: 0,
    setUnitDiscount: (unitDiscount) => set({ unitDiscount }),

    projectTheoreticalWeight: 0,
    setProjectTheoreticalWeight: (projectTheoreticalWeight) => set({ projectTheoreticalWeight }),

    projectTheoreticalLength: 0,
    setProjectTheoreticalLength: (projectTheoreticalLength) => set({ projectTheoreticalLength }),

    showCpCreationModal: false,
    setShowCpCreationModal: (value, navigate) => {
        set({ showCpCreationModal: value });

        const searchParams = new URLSearchParams(window.location.search);

        if (value) {
            searchParams.set("create-cutting-plan", "true");
        } else {
            searchParams.delete("create-cutting-plan");
        }

        navigate({
            search: `?${searchParams.toString()}`,
        });
    },

    rebars: [],
    setRebars: (rebars) => set({ rebars }),

    // to construct request body
    allFloors: [],
    setAllFloors: (allFloors) => set({ allFloors }),

    allDiameters: [],
    setAllDiameters: (allDiameters) => set({ allDiameters }),

    rebarInformation: {}, // donatiDict
    setRebarInformation: (rebarInformation) => set({ rebarInformation }),

    longRebars: [],
    setLongRebars: (longRebars) => set({ longRebars }),

    weights: {},
    setWeights: (weights) => set({ weights }),

    selectedLayoutElements: [],
    setSelectedLayoutElements: (selectedLayoutElements) => set({ selectedLayoutElements }),

    selectedExplanations: [],
    setSelectedExplanations: (selectedExplanations) => set({ selectedExplanations }),

    selectedDiameters: [],
    setSelectedDiameters: (selectedDiameters) => set({ selectedDiameters }),

    lengthInterval: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
    setLengthInterval: (lengthInterval) => set({ lengthInterval }),
}));